export class tempLogReq {
    uid: string[];

    constructor(uid:string[]){
        this.uid = uid;
    }
}